/* eslint-disable no-useless-constructor */
import FieldModel from './FieldModel';
import { SelectInput } from '../inputs';

class SelectField extends FieldModel {
  /**
   * @param {Object} params
   * @param {string} params.kWord Unique object key (from plans)
   * @param {string} params.label Input label, used on the field filter
   * @param {boolean} [params.required] If the input is required (not empty)
   * @param {boolean} [params.removed] Condition to not render and use this field
   * @param {boolean} [params.disabled] Condition to block this field (still visible)
   * @param {any} [params.default] Default (initial) value
   * @param {[{
   *  value: any, label: string, id: string
   * }]} params.options Select options list
   * @param {boolean} [params.multiple] If can select multiple options
   */
  constructor(params) {
    super(params);
  }

  getDefaultState = () => {
    const dt = {
      error: Boolean(this.required),
      errorMsg: this.required ? 'Este campo não pode estar vazio' : '',
    };
    if (this.multiple) {
      return ({
        selected: this.default ?? [],
        value: this.default?.map((d) => d.value) ?? [],
        ...dt,
      });
    }
    return ({
      ...(this.default ?? this.options[0]),
      ...dt,
    });
  };

  genFormatedState = (value) => {
    if (!value) return null;
    const dt = {
      error: false,
      errorMsg: '',
    };
    if (this.multiple) {
      dt.selected = this.options.filter((o) => value.includes(o.value));
      dt.value = dt.selected.map((s) => s.value);
      return dt;
    }
    return {
      ...(this.options.find((o) => o.value === value) ?? { value, label: value }),
      ...dt,
    };
  };

  fieldComponent = (tempState, state, handle) => {
    const prepHandle = (value) => {
      if (this.multiple) {
        handle({
          [this.kWord]: {
            selected: value,
            value: value.map((v) => v.value),
            error: false,
            errorMsg: '',
          },
        });
      } else {
        handle({
          [this.kWord]: {
            ...value,
            error: false,
            errorMsg: '',
          },
        });
      }
    };
    return (
      <SelectInput
        label={this.label}
        state={tempState?.[this.kWord] ?? state[this.kWord] ?? this.getDefaultState()}
        handle={prepHandle}
        options={this.options}
        isMultiple={this.multiple ?? false}
      />
    );
  };
}

export default SelectField;
